/**
 * Article sticky add-to-cart bar (alternative article template)
 */

function addVariantToCart(btn) {
  const variantId = parseInt(btn.dataset.atcVariant, 10);
  if (!variantId) return;

  const originalHTML = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '<span>Adding…</span>';

  const cartBody = { id: variantId, quantity: 1 };
  const sellingPlanId = parseInt(btn.dataset.atcSellingPlan, 10);
  if (sellingPlanId) cartBody.selling_plan = sellingPlanId;

  fetch(window.routes?.cart_add_url || '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(cartBody)
  })
    .then((res) => {
      if (!res.ok) {
        return res.json().then((data) => {
          const err = new Error(data.description || 'Could not add item to cart.');
          err.httpStatus = res.status;
          throw err;
        });
      }
      return res.json();
    })
    .then(() => {
      try { if (typeof clarity === 'function') clarity('event', 'article_sticky_atc_added'); } catch (e) {}
      const cartDrawer = document.querySelector('cart-form');
      if (cartDrawer && typeof cartDrawer.getCartData === 'function') {
        cartDrawer.getCartData('open_drawer');
      }
    })
    .catch((err) => {
      if (window.notificationEle?.updateNotification) {
        window.notificationEle.updateNotification('Cart', err.message, {
          type: 'error',
          timeout: 3000
        });
      }
      if (window.bubsTrackCartError) {
        window.bubsTrackCartError({
          http_status: err.httpStatus || 0,
          error_message: err.message || null,
          variant_id: variantId,
          quantity: 1,
          purchase_type: sellingPlanId ? 'subscription' : 'one_time',
          selling_plan_id: sellingPlanId || null,
          source: 'article_sticky_atc',
        });
      }
    })
    .finally(() => {
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    });
}

function initArticleStickyAtc() {
  const stickyBar = document.querySelector('.article-sticky-atc');
  const trigger = document.querySelector('[data-article-sticky-trigger]');
  const atcButton = stickyBar?.querySelector('[data-atc-variant]');

  if (!stickyBar || !trigger) return;

  if (atcButton) {
    atcButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (atcButton.disabled) return;
      try {
        if (typeof clarity === 'function') {
          clarity('event', 'article_sticky_atc_clicked');
          clarity('set', 'article_sticky_atc_product', atcButton.dataset.currentProductId || '');
        }
      } catch (e) {}
      addVariantToCart(atcButton);
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      const rect = entry.boundingClientRect;
      const scrolledPastArticleTop = !entry.isIntersecting && rect.top < 0;
      if (scrolledPastArticleTop && !stickyBar.classList.contains('sticky-btn')) {
        try { if (typeof clarity === 'function') clarity('event', 'article_sticky_atc_shown'); } catch (e) {}
      }
      stickyBar.classList.toggle('sticky-btn', scrolledPastArticleTop);
    },
    { threshold: 0 }
  );

  observer.observe(trigger);
}

function initArticleSidebarTracking() {
  const sidebar = document.querySelector('.block__article-sidebar-featured');
  if (sidebar) {
    sidebar.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      try {
        if (typeof clarity === 'function') {
          const title = sidebar.querySelector('.block__article-sidebar-featured-title')?.textContent?.trim() || '';
          clarity('event', 'article_sidebar_product_clicked');
          clarity('set', 'article_sidebar_product', title);
        }
      } catch (e) {}
    });
  }

  const socials = document.querySelector('.block__article-sidebar .card-socials');
  if (socials) {
    socials.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      try {
        if (typeof clarity === 'function') {
          const network = (link.getAttribute('title') || '').toLowerCase() || 'unknown';
          clarity('event', 'article_sidebar_social_clicked');
          clarity('set', 'article_sidebar_social', network);
        }
      } catch (e) {}
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initArticleStickyAtc();
    initArticleSidebarTracking();
  });
} else {
  initArticleStickyAtc();
  initArticleSidebarTracking();
}
